<template>
  <div>
    <b-navbar
      toggleable="lg"
      type="dark"
      variant="info"
      class="navbar-extended"
    >
      <a href="/">
        <img class="header-img" src="@/assets/img/header-logo.png" />
      </a>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav
          class="ml-auto d-flex align-items-center justify-content-end"
        >
          <b-nav-item class="mr-4" href="/carta-circular.pdf" target="_blank">
            <em class="far fa-file-alt color-primary-4 mr-2 font-16" />
            <span class="color-primary-4 font-14">
              {{ $t('LnkCircularLetter') }}
            </span>
          </b-nav-item>
          <b-nav-item
            class="mr-4"
            href="/manual-solicitante.pdf"
            target="_blank"
          >
            <em class="far fa-file-alt color-primary-4 mr-2 font-16" />
            <span class="color-primary-4 font-14">
              {{ $t('LnkManualSolicitante') }}
            </span>
          </b-nav-item>
          <b-nav-item class="mr-4" href="/memo-aclarativo.pdf" target="_blank">
            <em class="far fa-file-alt color-primary-4 mr-2 font-16" />
            <span class="color-primary-4 font-14">
              {{ $t('MemoAclarativo') }}
            </span>
          </b-nav-item>
          <div class="d-flex align-items-center">
            <span class="data-label">{{ $t('HeaderLanguageTitle') }}:</span>
            <custom-drop-action-item
              class="mr-4 pr-4 border-right"
              id="ddlLanguage"
              text="Idioma"
              v-model="selectedLanguage"
              :items="languageOptions"
              :set-selected-option="true"
              @click="onChangeLanguageHandler"
            />
          </div>
          <custom-drop-action-item
            is-icon-action
            class="mr-4"
            id="ddlUserProfile"
            text="Perfil"
            :items="userProfileOptions"
            @click="onSelectedUserProfileItem"
          >
            <img src="@/assets/img/user-icon.svg" />
          </custom-drop-action-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import { name as appModuleName } from '@/store/modules/app';
import { name as userModuleName } from '@/store/modules/user';

//components
import { CustomDropActionItem } from '@/components/common';

//mixins
import alertMixin from 'utils/mixins/alert.mixin';
import { userMixin } from '@/mixins/user.mixin';

//utils
import { i18n } from '@/i18n.js';

//constants
import languageOptionsEnum from '@/utils/constants/languageOptions.js';

import roles from '@/utils/constants/roles.js';

const CREATE_NEW_CASE_ROUTE_NAME = 'create-new-case';
const HOME_ROUTE_NAME = 'main';
const PROFILE_ROUTE_NAME = 'userProfile';
const SIGNIN_ROUTE_PATH = '/signin';

export default {
  name: 'TheHeader',
  mixins: [alertMixin, userMixin],
  components: {
    CustomDropActionItem,
  },
  props: {
    userInfo: {
      type: Object,
      default: () => ({}),
    },
    excludeHelpCard: {
      type: Array,
      default: () => [], //array strings, para excluir items de caja de ayuda
    },
    contactInfo: {
      type: Object,
      default: () => ({
        phone: '787-773-6147',
        mail: 'apoyoconversion@de.pr.gov',
      }),
    },
    logo: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isUserPasswordChangeVisible: false,
      selectedLanguage: null,
      accessOptions: [
        {
          label: i18n.t('VirtualLibrary'),
          icon: 'atlas',
          isButtonType: true,
          visible: true,
        },
        {
          label: i18n.t('LnkCircularLetter'),
          icon: 'file-alt',
          isButtonType: true,
          visible: true,
        },
        {
          label: i18n.t('MemoAclarativo'),
          icon: 'file-alt',
          isButtonType: true,
          visible: true,
        },
        {
          label: i18n.t('LnkManualSolicitante'),
          icon: 'file-alt',
          isButtonType: true,
          visible: true,
        },
        {
          label: i18n.t('SurveyRating'),
          icon: 'chart-bar',
          isButtonType: true,
          visible: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
      isNavOpened: 'getIsNavOpen',
    }),
    ...mapState(appModuleName, ['isCaseListOpen']),
    displayChangeUserPassword() {
      return this.isUserPasswordChangeVisible;
    },
    languageOptions() {
      return languageOptionsEnum;
    },
    userProfileOptions() {
      return [
        {
          id: 1,
          label: i18n.t('MyProfile'),
          icon: 'user font-20 mr-2',
          isButtonType: true,
        },
        {
          id: 2,
          label: i18n.t('Logout'),
          icon: 'power-off font-20 mr-2',
          isButtonType: true,
        },
      ];
    },
  },
  mounted() {
    this.loadSelectedLanguage();
  },
  methods: {
    ...mapMutations(appModuleName, ['setOpenCaseList']),
    ...mapActions(userModuleName, ['logout']),
    ...mapGetters(userModuleName, {
      roleName: 'role',
    }),
    isApplicant() {
      return this.roleName()?.toLowerCase() === roles.APPLICANT.toLowerCase();
    },
    ShowHidePasswordChange() {
      this.isUserPasswordChangeVisible = true;
    },
    onClosing() {
      this.isUserPasswordChangeVisible = false;
    },
    async createNewCaseHandler() {
      if (this.$route.name !== CREATE_NEW_CASE_ROUTE_NAME) {
        if (this.itemModel?.businessId) {
          const answer = await this.ShowCancelModal(
            'Crear Nuevo Caso',
            '¿Está seguro que desea crear un nuevo caso?',
            'Si',
            'No'
          );
          if (answer) {
            this.disposeCaseInfo();
            this.$router.push({
              name: CREATE_NEW_CASE_ROUTE_NAME,
            });
          }
        } else {
          this.disposeCaseInfo();
          this.$router.push({
            name: CREATE_NEW_CASE_ROUTE_NAME,
          });
        }
      } else {
        this.disposeCaseInfo();
      }
    },
    goToHomeHandler() {
      this.disposeCaseInfo();
      if (this.isMobile) {
        this.setOpenCaseList(false);
      }
      if (this.$route.name !== HOME_ROUTE_NAME) {
        this.setIsNavOpen({
          isNavOpen: false,
          navOption: {},
        });
        this.$router.replace({
          name: HOME_ROUTE_NAME,
        });
      }
    },
    openCaseListHandler() {
      this.setOpenCaseList(!this.isCaseListOpen);
    },
    async onSelectedUserProfileItem(value) {
      // My profile
      if (value?.id === 1) {
        this.$router.push({
          name: PROFILE_ROUTE_NAME,
        });
      }

      if (value?.id === 2) {
        // Logout
        await this.logout();
        window.location.replace(SIGNIN_ROUTE_PATH);
      }
    },
    onChangeLanguageHandler(value) {
      if (value?.id) {
        this.$i18n.locale = value.id;
        window.location.reload();
      }
    },
    loadSelectedLanguage() {
      this.selectedLanguage = this.languageOptions.find(
        (x) => x.id === this.userSelectedLang
      );

      this.accessOptions = this.accessOptions.filter((o) =>
        this.isApplicant() ? o.visible : !this.isApplicant()
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/bootstrap/_colors.scss';

.navbar-extended {
  height: 89px;
  background: #fff !important;
  &--is-normal {
    right: 0px !important;
  }
}

.header-img {
  height: 69px;
  margin-top: 3px;
}

@media only screen and (max-width: 768px) {
  .header-img {
    height: 45px;
  }
}
</style>
